// Resolves a thrown error to the copy the user should see on 건강백과.
//
// SHCT-712 already established the rule here — never publish the server's text, degrade to the
// caller's operation copy — and SHCT-702 found the same defect in every other feature. The rule now
// lives in one shared resolver so it cannot drift back apart; this stays as the feature's entry point.

import type { TFunction } from 'i18next';

import { resolveApiErrorMessage } from '@/shared/utils/api-error-message';

import { HealthEncyclopediaApiError } from '../types/health-encyclopedia.types';

export function getEncyclopediaErrorMessage(
  err: unknown,
  t: TFunction,
  fallbackKey: string,
): string {
  const code = err instanceof HealthEncyclopediaApiError ? err.code : null;
  return resolveApiErrorMessage(t, code, fallbackKey);
}
